import { useScrollFadeIn, staggerStyle } from "@/hooks/useScrollFadeIn";

const linkItems = [
  {
    id: 1,
    label: 'note',
    sub: 'note.com/mugi_cha_sm',
    desc: '日々の思いやプレイの記録',
    url: 'https://note.com/mugi_cha_sm',
    icon: 'ri-book-open-line',
    badge: 'Blog',
    accentColor: 'bg-emerald-500',
    badgeBg: 'bg-emerald-50 text-emerald-600 border border-emerald-200',
    iconBg: 'bg-emerald-100',
    iconColor: 'text-emerald-600',
    labelColor: 'text-stone-900',
    subColor: 'text-stone-400',
    descColor: 'text-stone-500',
    iconImg: 'https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/9b94f6d6-06a0-46b1-b3cf-f54040fe5bff_S__23969800.jpg?v=357e1c482f220f4524e46493444e5f97',
  },
  {
    id: 2,
    label: 'むぎ茶の資料室',
    sub: 'muginox.hatenablog.com',
    desc: '過去の記事アーカイブ',
    url: 'https://muginox.hatenablog.com/',
    icon: 'ri-history-line',
    badge: '旧Blog',
    accentColor: 'bg-orange-400',
    badgeBg: 'bg-orange-50 text-orange-600 border border-orange-200',
    iconBg: 'bg-orange-100',
    iconColor: 'text-orange-500',
    labelColor: 'text-stone-900',
    subColor: 'text-stone-400',
    descColor: 'text-stone-500',
  },
  {
    id: 3,
    label: 'Lit.Link',
    sub: 'lit.link/hatomugicha91',
    desc: '最新のスケジュールはこちら',
    url: 'https://lit.link/hatomugicha91',
    icon: 'ri-links-line',
    badge: 'Links',
    accentColor: 'bg-fuchsia-500',
    badgeBg: 'bg-fuchsia-50 text-fuchsia-600 border border-fuchsia-200',
    iconBg: 'bg-fuchsia-100',
    iconColor: 'text-fuchsia-600',
    labelColor: 'text-stone-900',
    subColor: 'text-stone-400',
    descColor: 'text-stone-500',
  },
];

const snsItems = [
  {
    id: 4,
    label: 'むぎ茶',
    sub: '@mazo_kawaii',
    desc: 'メインアカウント — 活動・動画',
    url: 'https://x.com/mazo_kawaii',
    badge: 'MAIN',
    badgeStyle: 'bg-stone-900 text-white',
    cardBg: 'bg-stone-900',
    labelColor: 'text-white',
    subColor: 'text-stone-400',
    descColor: 'text-stone-400',
    arrowColor: 'text-stone-500 group-hover:text-white',
    iconImg: 'https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/5b022117-e756-4786-9a97-034c6ebfd4e3_S__23969797_0.jpg?v=492b65e79c17c84a9dd1643c4798a85f',
    xIconColor: 'text-white',
    ringColor: 'ring-white/20',
  },
  {
    id: 5,
    label: 'からだめぐりむぎ茶',
    sub: '@mazo_kawaii2',
    desc: 'サブアカウント — 日常と性癖',
    url: 'https://x.com/mazo_kawaii2',
    badge: 'SUB',
    badgeStyle: 'bg-amber-500 text-white',
    cardBg: 'bg-amber-50',
    labelColor: 'text-stone-900',
    subColor: 'text-amber-600',
    descColor: 'text-stone-500',
    arrowColor: 'text-amber-300 group-hover:text-amber-600',
    iconImg: 'https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/f9a88f65-0857-4df2-87a9-698e41133632_S__23969798_0.jpg?v=1b9fa3b045519623d79708f34341e7f3',
    xIconColor: 'text-amber-500',
    ringColor: 'ring-amber-200',
    border: 'border border-amber-100',
  },
  {
    id: 6,
    label: 'お仕置きBAR【公式】',
    sub: '@osioki_bar',
    desc: '開催情報・イベント告知',
    url: 'https://x.com/osioki_bar',
    badge: 'BAR',
    badgeStyle: 'bg-rose-500 text-white',
    cardBg: 'bg-rose-50',
    labelColor: 'text-stone-900',
    subColor: 'text-rose-500',
    descColor: 'text-stone-500',
    arrowColor: 'text-rose-300 group-hover:text-rose-500',
    iconImg: 'https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/9cf867d1-8180-4b36-bac5-2558da642005_S__23969799_0.jpg?v=27114da17e303e86c049046c55eb620a',
    xIconColor: 'text-rose-400',
    ringColor: 'ring-rose-200',
    border: 'border border-rose-100',
  },
];

interface LinkCardProps {
  item: typeof linkItems[number];
  index: number;
  visible: boolean;
}

/** note専用ヒーローカード */
function MainNoteLinkCard({ item, visible }: { item: typeof linkItems[number]; visible: boolean }) {
  return (
    <a
      href={item.url}
      target="_blank"
      rel="noopener noreferrer nofollow"
      className="group relative flex flex-col items-center text-center rounded-2xl px-5 pt-7 pb-6 cursor-pointer overflow-hidden bg-emerald-950 border border-emerald-900 hover:border-emerald-600 transition-all duration-300 hover:-translate-y-1"
      style={staggerStyle(visible, 0, 0.05, 0.08)}
    >
      {/* 背景グロー — ホバーで強まる */}
      <div className="absolute inset-0 bg-gradient-to-br from-emerald-900/50 via-transparent to-emerald-950/80 pointer-events-none transition-opacity duration-300" />
      <div className="absolute inset-0 bg-emerald-500/0 group-hover:bg-emerald-500/[0.06] pointer-events-none transition-all duration-300" />
      <div className="absolute -top-14 -right-14 w-44 h-44 rounded-full bg-emerald-400/[0.06] group-hover:bg-emerald-400/[0.12] pointer-events-none transition-all duration-300" />
      <div className="absolute -bottom-10 -left-10 w-36 h-36 rounded-full bg-emerald-400/[0.04] group-hover:bg-emerald-400/[0.08] pointer-events-none transition-all duration-300" />

      {/* Blogバッジ */}
      <span className="relative z-10 mb-4 text-[10px] tracking-[0.35em] font-bold px-3 py-1 rounded-full bg-emerald-400/10 text-emerald-300/80 border border-emerald-400/20 uppercase">
        Blog
      </span>

      {/* アイコン — ホバーで拡大 */}
      <div className="relative z-10 mb-4 transition-transform duration-300 group-hover:scale-110">
        <div className="w-16 h-16 rounded-full overflow-hidden ring-2 ring-emerald-400/20 group-hover:ring-emerald-400/50 mx-auto transition-all duration-300">
          {'iconImg' in item && item.iconImg ? (
            <img src={item.iconImg as string} alt={item.label} className="w-full h-full object-cover" />
          ) : (
            <div className={`w-full h-full flex items-center justify-center ${item.iconBg}`}>
              <i className={`${item.icon} ${item.iconColor} text-3xl`}></i>
            </div>
          )}
        </div>
        {/* noteロゴバッジ */}
        <div className="absolute -bottom-1 -right-1 w-7 h-7 flex items-center justify-center rounded-full bg-emerald-500 shadow transition-transform duration-300 group-hover:scale-110">
          <i className="ri-book-open-line text-sm text-white"></i>
        </div>
      </div>

      {/* 名前・URL */}
      <p className="relative z-10 text-base font-bold text-white mb-0.5 group-hover:text-emerald-100 transition-colors duration-200">{item.label}</p>
      <p className="relative z-10 text-xs text-emerald-400/70 mb-1">{item.sub}</p>
      <p className="relative z-10 text-[11px] text-emerald-300/50 mb-5">{item.desc}</p>

      {/* ボタン */}
      <div className="relative z-10 w-full flex items-center justify-center gap-2 py-2.5 rounded-xl bg-emerald-500 text-white font-bold text-sm group-hover:bg-emerald-400 transition-all duration-200">
        <i className="ri-book-open-line text-base"></i>
        <span>記事を読む</span>
        <i className="ri-arrow-right-line text-sm group-hover:translate-x-1 transition-transform duration-200"></i>
      </div>
    </a>
  );
}

function LinkCard({ item, index, visible }: LinkCardProps) {
  return (
    <a
      href={item.url}
      target="_blank"
      rel="noopener noreferrer nofollow"
      className="group flex items-center gap-4 bg-white border border-stone-100 rounded-2xl px-5 py-4 cursor-pointer transition-all duration-200 hover:-translate-y-0.5 hover:border-stone-300 active:translate-y-0 active:brightness-95"
      style={staggerStyle(visible, index, 0.05, 0.08)}
    >
      {/* アクセントライン */}
      <div className={`w-1 h-10 rounded-full flex-shrink-0 ${item.accentColor}`} />

      {/* アイコン — ホバーで軽く拡大 */}
      <div className={`w-10 h-10 flex items-center justify-center rounded-xl flex-shrink-0 ${item.iconBg} transition-transform duration-200 group-hover:scale-110`}>
        <i className={`${item.icon} ${item.iconColor} text-lg`}></i>
      </div>

      {/* テキスト */}
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 mb-0.5">
          <p className={`text-sm font-bold ${item.labelColor}`}>{item.label}</p>
          <span className={`text-[10px] px-2 py-0.5 rounded-full font-semibold tracking-wider whitespace-nowrap ${item.badgeBg}`}>
            {item.badge}
          </span>
        </div>
        <p className={`text-xs ${item.descColor} truncate`}>{item.desc}</p>
        <p className={`text-[11px] ${item.subColor} mt-0.5 truncate`}>{item.sub}</p>
      </div>

      <i className="ri-arrow-right-line text-base text-stone-300 group-hover:text-stone-600 group-hover:translate-x-1 transition-all duration-200 flex-shrink-0"></i>
    </a>
  );
}

interface SnsCardProps {
  item: typeof snsItems[number];
  index: number;
  visible: boolean;
}

/** むぎ茶（MAIN）専用の大きなヒーローカード */
function MainSnsCard({ item, visible }: { item: typeof snsItems[number]; visible: boolean }) {
  return (
    <a
      href={item.url}
      target="_blank"
      rel="noopener noreferrer nofollow"
      className="group relative flex flex-col items-center text-center rounded-2xl px-5 pt-7 pb-6 cursor-pointer overflow-hidden bg-stone-950 border border-stone-800 hover:border-stone-500 transition-all duration-300 hover:-translate-y-1"
      style={staggerStyle(visible, 0, 0.05, 0.08)}
    >
      {/* 背景グロー — ホバーで強まる */}
      <div className="absolute inset-0 bg-gradient-to-br from-stone-800/40 via-transparent to-stone-900/60 pointer-events-none" />
      <div className="absolute inset-0 bg-white/0 group-hover:bg-white/[0.03] pointer-events-none transition-all duration-300" />
      <div className="absolute -top-16 -right-16 w-48 h-48 rounded-full bg-white/[0.03] group-hover:bg-white/[0.06] pointer-events-none transition-all duration-300" />
      <div className="absolute -bottom-10 -left-10 w-36 h-36 rounded-full bg-white/[0.02] group-hover:bg-white/[0.05] pointer-events-none transition-all duration-300" />

      {/* MAINバッジ */}
      <span className="relative z-10 mb-4 text-[10px] tracking-[0.35em] font-bold px-3 py-1 rounded-full bg-white/10 text-white/70 border border-white/10 uppercase">
        MAIN ACCOUNT
      </span>

      {/* アイコン — ホバーで拡大 */}
      <div className="relative z-10 mb-4 transition-transform duration-300 group-hover:scale-110">
        <div className="w-16 h-16 rounded-full overflow-hidden ring-2 ring-white/20 group-hover:ring-white/40 mx-auto transition-all duration-300">
          <img src={item.iconImg} alt={item.label} className="w-full h-full object-cover" />
        </div>
        {/* Xバッジ */}
        <div className="absolute -bottom-1 -right-1 w-7 h-7 flex items-center justify-center rounded-full bg-white shadow transition-transform duration-300 group-hover:scale-110">
          <i className="ri-twitter-x-line text-sm text-stone-900"></i>
        </div>
      </div>

      {/* 名前・ハンドル */}
      <p className="relative z-10 text-base font-bold text-white mb-0.5 group-hover:text-stone-100 transition-colors duration-200">{item.label}</p>
      <p className="relative z-10 text-xs text-stone-400 mb-1">{item.sub}</p>
      <p className="relative z-10 text-[11px] text-stone-500 mb-5">{item.desc}</p>

      {/* フォローボタン */}
      <div className="relative z-10 w-full flex items-center justify-center gap-2 py-2.5 rounded-xl bg-white text-stone-900 font-bold text-sm group-hover:bg-stone-100 transition-all duration-200">
        <i className="ri-twitter-x-line text-base"></i>
        <span>プロフィールを見る</span>
        <i className="ri-arrow-right-line text-sm group-hover:translate-x-1 transition-transform duration-200"></i>
      </div>
    </a>
  );
}

/** サブ・BARアカウント用コンパクトカード */
function SubSnsCard({ item, index, visible }: SnsCardProps) {
  return (
    <a
      href={item.url}
      target="_blank"
      rel="noopener noreferrer nofollow"
      className={`group flex items-center gap-4 rounded-2xl px-5 py-4 cursor-pointer transition-all duration-200 hover:-translate-y-0.5 active:translate-y-0 active:brightness-95 ${item.cardBg} ${item.border ?? ''}`}
      style={staggerStyle(visible, index, 0.05, 0.08)}
    >
      {/* アイコン画像 — ホバーで拡大 */}
      <div className={`w-12 h-12 rounded-full overflow-hidden flex-shrink-0 ring-2 ${item.ringColor} transition-transform duration-200 group-hover:scale-110`}>
        <img src={item.iconImg} alt={item.label} className="w-full h-full object-cover" />
      </div>

      {/* テキスト */}
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 mb-0.5">
          <p className={`text-sm font-bold truncate ${item.labelColor}`}>{item.label}</p>
          <span className={`text-[10px] px-2 py-0.5 rounded-full font-bold tracking-wider whitespace-nowrap flex-shrink-0 ${item.badgeStyle}`}>
            {item.badge}
          </span>
        </div>
        <p className={`text-xs font-medium ${item.subColor}`}>{item.sub}</p>
        <p className={`text-xs mt-0.5 ${item.descColor}`}>{item.desc}</p>
      </div>

      {/* X アイコン + 矢印 */}
      <div className="flex flex-col items-center gap-1 flex-shrink-0">
        <i className={`ri-twitter-x-line text-sm ${item.xIconColor}`}></i>
        <i className={`ri-arrow-right-line text-sm group-hover:translate-x-1 transition-transform duration-200 ${item.arrowColor}`}></i>
      </div>
    </a>
  );
}

export default function BlogSNSSection() {
  const { ref: headRef, style: headStyle } = useScrollFadeIn<HTMLDivElement>({ threshold: 0.08, delay: 0 });
  const { ref: linksRef, visible: linksVisible } = useScrollFadeIn<HTMLDivElement>({ threshold: 0.06, delay: 0.05 });
  const { ref: snsRef, visible: snsVisible } = useScrollFadeIn<HTMLDivElement>({ threshold: 0.06, delay: 0.05 });

  return (
    <section id="blog" className="py-20 md:py-20 bg-white">
      <div className="max-w-4xl mx-auto px-5 md:px-10">

        {/* セクションヘッダー */}
        <div ref={headRef} style={headStyle} className="mb-8">
          <p className="text-[10px] tracking-[0.45em] text-stone-400 uppercase font-semibold mb-2">Links & SNS</p>
          <h2 className="text-xl font-bold text-stone-900 leading-none m-0 p-0">リンク一覧</h2>
        </div>

        {/* LINKS ゾーン */}
        <div className="mb-8">
          <div className="flex items-center gap-3 mb-4">
            <span className="text-[11px] tracking-[0.3em] text-stone-400 uppercase font-bold">Links</span>
            <div className="flex-1 h-px bg-stone-100"></div>
          </div>
          <div ref={linksRef} className="flex flex-col gap-2.5">
            {/* noteだけヒーローカードで大きく */}
            <MainNoteLinkCard item={linkItems[0]} visible={linksVisible} />
            {/* 残り2件はコンパクトカード */}
            {linkItems.slice(1).map((item, i) => (
              <LinkCard key={item.id} item={item} index={i + 1} visible={linksVisible} />
            ))}
          </div>
        </div>

        {/* SNS ゾーン */}
        <div>
          <div className="flex items-center gap-3 mb-4">
            <span className="text-[11px] tracking-[0.3em] text-stone-400 uppercase font-bold">SNS / X</span>
            <div className="flex-1 h-px bg-stone-100"></div>
          </div>
          <div ref={snsRef} className="flex flex-col gap-2.5">
            {/* むぎ茶 MAINカードを大きく表示 */}
            <MainSnsCard item={snsItems[0]} visible={snsVisible} />
            {/* サブアカウント2つをコンパクトに */}
            {snsItems.slice(1).map((item, i) => (
              <SubSnsCard key={item.id} item={item} index={i + 1} visible={snsVisible} />
            ))}
          </div>
        </div>

      </div>
    </section>
  );
}